module.exports = __webpack_public_path__ + "static/media/watertower.045e5aea.png";